export default __webpack_public_path__ + "static/media/af0621239ace26527599934aec7760d2.2166cf13.svg";